module.exports = {
  tag: 'unlucky',
  quality: 0.05,
  loot_bonus: -0.01,
};
